import React from "react"

const SettingsTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <>
      {/* Desktop: Horizontal tabs */}
      <div className="hidden sm:block">
        <nav className="flex space-x-1 bg-gray-100 p-1 rounded-xl" aria-label="Settings tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
                ${activeTab === tab.id
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
                }
              `}
              aria-selected={activeTab === tab.id}
              role="tab"
            >
              <span className={`${activeTab === tab.id ? "text-indigo-600" : "text-gray-400"}`}>
                {tab.icon}
              </span>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Mobile: Dropdown selector */}
      <div className="sm:hidden">
        <label htmlFor="settings-tab-select" className="sr-only">
          Select a settings tab
        </label>
        <div className="relative">
          <select
            id="settings-tab-select"
            value={activeTab}
            onChange={(e) => onTabChange(e.target.value)}
            className="block w-full rounded-xl border-gray-300 bg-white py-3 pl-4 pr-10 text-base font-medium text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 appearance-none"
          >
            {tabs.map((tab) => (
              <option key={tab.id} value={tab.id}>
                {tab.label}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
            </svg>
          </div>
        </div>

        {/* Mobile tab indicator pills */}
        <div className="flex gap-1.5 justify-center mt-3">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                h-1.5 rounded-full transition-all duration-200
                ${activeTab === tab.id
                  ? "w-6 bg-indigo-600"
                  : "w-1.5 bg-gray-300 hover:bg-gray-400"
                }
              `}
              aria-label={`Go to ${tab.label}`}
            />
          ))}
        </div>
      </div>
    </>
  )
}

export default SettingsTabs
